// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overlay {
    position: fixed;
    top: 100px;
    right: 0;
    height: 350px;
    width: 480px;
    overflow: hidden;
    background-color: #f4f4f4;
    z-index: 10;
    transform: translateX(100%);
    -webkit-transform: translateX(100%);
    padding: 25px 45px;
}

.overlay-content {
    display: flex;
    /* margin-top: 20%;
    margin-left: 187px; */
    flex-direction: column;
    align-items: flex-end;
}

.overlay a {
    padding: 8px;
    text-decoration: none;
    font-size: 22px;
    color: #000;
    display: block;
    transition: 0.3s;
    line-height: 1;
}

.overlay a:hover,
.overlay a:focus {
    color:#ff5800;
}

.selected {
    animation: slide-in 0.5s forwards;
    -webkit-animation: slide-in 0.5s forwards;
}

.dismiss {
    animation: slide-out 0.5s forwards;
    -webkit-animation: slide-out 0.5s forwards;
}

@keyframes slide-in {
    0% {
        -webkit-transform: translateX(100%);
    }
    100% {
        -webkit-transform: translateX(0%);
    }
}

@keyframes slide-out {
    0% {
        transform: translateX(0%);
    }
    100% {
        transform: translateX(100%);
    }
}

@media screen and (max-height: 450px) {
    .overlay a {
        font-size: 20px;
    }
    .overlay .closebtn {
        font-size: 40px;
        top: 15px;
        right: 35px;
    }
   
}
@media (max-width: 575.98px) {
    .overlay {
        top: 70px;
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/css/common/sideBar.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,UAAU;IACV,QAAQ;IACR,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,WAAW;IACX,2BAA2B;IAC3B,mCAAmC;IACnC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb;yBACqB;IACrB,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,eAAe;IACf,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,iCAAiC;IACjC,yCAAyC;AAC7C;;AAEA;IACI,kCAAkC;IAClC,0CAA0C;AAC9C;;AAEA;IACI;QACI,mCAAmC;IACvC;IACA;QACI,iCAAiC;IACrC;AACJ;;AAWA;IACI;QACI,yBAAyB;IAC7B;IACA;QACI,2BAA2B;IAC/B;AACJ;;AAWA;IACI;QACI,eAAe;IACnB;IACA;QACI,eAAe;QACf,SAAS;QACT,WAAW;IACf;;AAEJ;AACA;IACI;QACI,SAAS;QACT,WAAW;IACf;AACJ","sourcesContent":[".overlay {\n    position: fixed;\n    top: 100px;\n    right: 0;\n    height: 350px;\n    width: 480px;\n    overflow: hidden;\n    background-color: #f4f4f4;\n    z-index: 10;\n    transform: translateX(100%);\n    -webkit-transform: translateX(100%);\n    padding: 25px 45px;\n}\n\n.overlay-content {\n    display: flex;\n    /* margin-top: 20%;\n    margin-left: 187px; */\n    flex-direction: column;\n    align-items: flex-end;\n}\n\n.overlay a {\n    padding: 8px;\n    text-decoration: none;\n    font-size: 22px;\n    color: #000;\n    display: block;\n    transition: 0.3s;\n    line-height: 1;\n}\n\n.overlay a:hover,\n.overlay a:focus {\n    color:#ff5800;\n}\n\n.selected {\n    animation: slide-in 0.5s forwards;\n    -webkit-animation: slide-in 0.5s forwards;\n}\n\n.dismiss {\n    animation: slide-out 0.5s forwards;\n    -webkit-animation: slide-out 0.5s forwards;\n}\n\n@keyframes slide-in {\n    0% {\n        -webkit-transform: translateX(100%);\n    }\n    100% {\n        -webkit-transform: translateX(0%);\n    }\n}\n\n@-webkit-keyframes slide-in {\n    0% {\n        transform: translateX(100%);\n    }\n    100% {\n        transform: translateX(0%);\n    }\n}\n\n@keyframes slide-out {\n    0% {\n        transform: translateX(0%);\n    }\n    100% {\n        transform: translateX(100%);\n    }\n}\n\n@-webkit-keyframes slide-out {\n    0% {\n        -webkit-transform: translateX(0%);\n    }\n    100% {\n        -webkit-transform: translateX(100%);\n    }\n}\n\n@media screen and (max-height: 450px) {\n    .overlay a {\n        font-size: 20px;\n    }\n    .overlay .closebtn {\n        font-size: 40px;\n        top: 15px;\n        right: 35px;\n    }\n   \n}\n@media (max-width: 575.98px) {\n    .overlay {\n        top: 70px;\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
